export default {
  // Navigation
  'nav.customize': 'Personalizar',
  'nav.gallery': 'Galería',
  'nav.etsy_shop': 'Tienda Etsy',
  
  // Hero Section
  'hero.title': 'Crea momentos inolvidables',
  'hero.subtitle': 'Personaliza cajas de regalo, piñatas, camisetas y grabados 3D. Diseña tu producto perfecto y visualízalo en tiempo real.',
  'hero.cta_customize': 'Comenzar a Personalizar',
  'hero.cta_gallery': 'Ver Galería',
  'hero.cta_etsy': 'Comprar en Etsy',
  'hero.badge': 'Artículos para Fiestas Hechos a Mano en NYC',
  'hero.stats_customers': 'Clientes Felices',
  'hero.stats_handmade': 'Hecho a Mano',
  'hero.stats_support': 'Soporte',
  
  // Home Page
  'home.categories_title': 'Comprar por Categoría',
  'home.categories_subtitle': 'Explora nuestra colección de artículos para fiestas hechos a mano',
  'home.why_choose_us': '¿Por Qué Elegirnos?',
  'home.why_subtitle': 'Creamos artículos únicos para fiestas con amor y dedicación',
  'home.feature_1_title': '100% Personalizable',
  'home.feature_1_desc': 'Diseña tus artículos perfectos con nuestras herramientas de personalización fáciles de usar',
  'home.feature_2_title': 'Hecho a Mano con Amor',
  'home.feature_2_desc': 'Cada artículo es cuidadosamente elaborado a mano con atención al detalle',
  'home.feature_3_title': 'Envío Rápido',
  'home.feature_3_desc': 'Entrega rápida para hacer tu celebración inolvidable',
  'home.cta_title': '¿Listo para Hacer tu Fiesta Especial?',
  'home.cta_subtitle': 'Explora nuestra colección y ordena tus artículos personalizados hoy',
  'home.cta_contact': 'Contáctanos',
  
  // Categories
  'categories.title': 'Comprar por Categoría',
  'categories.subtitle': 'Explora nuestra colección de artículos para fiestas hechos a mano',
  'categories.products': 'productos',
  'categories.explore': 'Explorar',
  
  'categories.pinatas': 'Piñatas',
  'categories.pinatas_desc': 'Piñatas personalizadas de estrella y números con colores vibrantes',
  'categories.banners': 'Banners de Fiesta',
  'categories.banners_desc': 'Banners personalizados para cualquier celebración',
  'categories.stickers': 'Stickers Personalizados',
  'categories.stickers_desc': 'Hojas de stickers personalizados (4x7 pulgadas)',
  'categories.tshirts': 'Camisetas Personalizadas',
  'categories.tshirts_desc': 'Camisetas personalizadas con tu diseño',
  'categories.favor_boxes': 'Cajas de Recuerdos',
  'categories.favor_boxes_desc': 'Hermosas cajas para recuerdos de fiesta',
  'categories.engraving': 'Grabado 3D',
  'categories.engraving_desc': 'Decoraciones de madera cortadas con láser',
  
  // Products
  'products.featured_title': 'Productos Populares',
  'products.featured_subtitle': 'Nuestras creaciones más queridas',
  'products.view_all': 'Ver Todo',
  'products.star_pinata': 'Piñata de Estrella',
  'products.number_5_pinata': 'Piñata Número 5',
  'products.custom_banner': 'Banner Personalizado',
  'products.sticker_sheet': 'Hoja de Stickers',
  
  // Features
  'features.custom_title': '100% Personalizable',
  'features.custom_desc': 'Diseña tus artículos perfectos con nuestras herramientas de personalización',
  'features.handmade_title': 'Hecho a Mano con Amor',
  'features.handmade_desc': 'Cada artículo es cuidadosamente elaborado a mano con atención al detalle',
  'features.shipping_title': 'Envío Rápido',
  'features.shipping_desc': 'Entrega rápida para hacer tu celebración inolvidable',
  
  // Footer
  'footer.description': 'Artículos para fiestas hechos a mano en NYC',
  'footer.quick_links': 'Enlaces Rápidos',
  'footer.contact': 'Contacto',
  'footer.tagline': 'Artículos para fiestas hechos a mano en NYC',
  'footer.shop': 'Tienda',
  'footer.customize': 'Personalizar',
  'footer.gallery': 'Galería',
  'footer.etsy': 'Tienda Etsy',
  'footer.categories': 'Categorías',
  'footer.connect': 'Conectar',
  'footer.rights': 'Todos los derechos reservados.',
  
  // Customize Page
  'customize.title': 'Personaliza Tu Producto',
  'customize.select_category': 'Selecciona una categoría para comenzar',
  'customize.select_product': 'Elige Tu Producto',
  'customize.select_product_desc': 'Selecciona el producto que deseas personalizar',
  'customize.back': 'Volver',
  'customize.home': 'Inicio',
  'customize.no_products': 'No hay productos disponibles',
  'customize.no_products_desc': 'Esta categoría aún no tiene productos.',
  'customize.customizing': 'Personalizando',
  'customize.design_desc': 'Diseña tu producto perfecto con nuestra herramienta de personalización 3D',
  'customize.in_development': 'Personalizador en Desarrollo',
  'customize.in_development_desc': 'El personalizador para este producto estará disponible pronto.',
  'customize.view_etsy': 'Ver en Etsy',
  
  // Gallery
  'gallery.title': 'Nuestra Galería',
  'gallery.subtitle': 'Explora nuestra colección de creaciones hechas a mano',
  'gallery.all': 'Todo',
  'gallery.no_products': 'No se encontraron productos',
  'gallery.no_products_desc': 'Intenta seleccionar una categoría diferente.',
  'gallery.loading': 'Cargando...',
};
